// extracted by mini-css-extract-plugin
export default {"BackToTopButton":"BackToTopButton-styles__BackToTopButton__svW40","BackToTopButton__icon":"BackToTopButton-styles__BackToTopButton__icon__clMUD"};